import { useState } from "react";
import { useParams } from "react-router-dom";
import MainLayouts from "../layouts/MainLayouts";
import { useTranslation } from "react-i18next";
import ShareModal from "../components/news/ShareModal";
import NewsContentSection from "../components/news/NewsContentSection";
import SimilarItemsSection from "../components/shared/SimilarItemsSection";
import NewsCard from "../components/NewsCard";
import { INewsFlat } from "../domain/models/News";
import { newsServiceFactory } from "../services/NewsServiceImpl";
import { useQuery } from "@tanstack/react-query";
import LoadingPanel from "../custom-components/CustomLoader";
import Button from "../components/ui/Button";
import { ButtonVariant } from "../types/constants";
import { useNavigate } from "react-router-dom";

const newsService = newsServiceFactory();

export default function NewsDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const { t, i18n } = useTranslation();
    const newsUrl = window.location.href;

    const {
        data: news,
        isLoading,
        isError,
    } = useQuery({
        queryKey: ["news", id, i18n.language],
        queryFn: async () => await newsService.getNewsById(id!),
        enabled: !!id,
    });

    if (isLoading) {
        return <LoadingPanel isVisible={isLoading} />;
    }

    if (isError || !news) {
        return (
            <MainLayouts pageTitle="">
                <div className="text-center py-20 text-5xl lg:max-w-[1280px] container flex flex-col justify-center items-center gap-12">
                    <h1>{t("news.notFound")}</h1>
                    <Button onClick={() => navigate(-1)} text={t("common.back")} variant={ButtonVariant.BACK} />
                </div>
            </MainLayouts>
        );
    }

    return (
        <MainLayouts pageTitle={news.title}>
            <NewsContentSection news={news} onShare={() => setIsShareModalOpen(true)} />

            <SimilarItemsSection<INewsFlat>
                currentItemId={id!}
                fetchItems={(page, limit) => newsService.getAllNews(page, limit)}
                renderCard={(item) => <NewsCard news={item} />}
                translationKey="news.similarSection.title"
                queryKeyBase="news"
            />

            <ShareModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                newsTitle={news.title}
                newsUrl={newsUrl}
            />
        </MainLayouts>
    );
}
